
  import { Component, Vue }                     from 'vue-property-decorator';
  import { Getter }                             from 'vuex-class';
  import   FloatingWidgetComponent              from '../../features/widget/FloatingWidgetComponent.vue';
  import   EmbeddedWidgetComponent              from '../../features/widget/EmbeddedWidgetComponent.vue';


  @Component({
    name: 'ChatView',
    components: {
      FloatingWidgetComponent,
      EmbeddedWidgetComponent,
    }
  })
  export default class ChatView extends Vue {
    @Getter('isEmbeddedMode', { namespace: 'conversationSession' }) isEmbeddedMode!: boolean | undefined;
    @Getter('currentSessionId', { namespace: 'conversationSession' }) currentSessionId!: string | undefined;
  }
